import Event from '../../core/Event';
import { OrderStocks } from '../../../domain/Order';
import Product from '../../../domain/Product';

export default class OrderChangeConfirmed extends Event {
    public static type = 'OrderChangeConfirmed';

    constructor(
        public readonly product: Product,
        public readonly value: number,
        public readonly sku: string,
        public readonly variantCode: string,
        public readonly field: keyof OrderStocks
    ) {
        super(OrderChangeConfirmed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderChangeConfirmed.ts